import React, { type FC, useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router';

import { type SigningTypeSwitcherOption } from './types';

import { SegmentedControl } from 'app/design-system/components/SegmentedControl';
import { useTranslation } from 'app/lang';

import { AuthModalQuery, createAuthQuery } from '../../utils/auth-modals-query';

import dictionary from './SigningTypeSwitcher.dictionary.json';

import styles from './SigningTypeSwitcher.module.scss';

export const SigningTypeSwitcher: FC = () => {
  const { replace } = useHistory();
  const { lang, t } = useTranslation();
  const { search } = useLocation();

  const options  = useMemo<SigningTypeSwitcherOption[]>(() => [
    {
      id: AuthModalQuery.LOGIN,
      value: t(dictionary.switcherLabelPassword),
      dataTest: 'ModalLogin-button-enterPassword',
      dataGaEvent: 'SignEnterPassword',
      dataGaEventValue: 'headerMenuPassword',
    },
    {
      id: AuthModalQuery.SIGN,
      value: t(dictionary.switcherLabelCode),
      dataTest: 'ModalLogin-button-enterWithCode',
      dataGaEvent: 'SignEnterCode',
      dataGaEventValue: 'headerMenuCode',
    },
  ], [lang]);

  const handleSelectOption = useCallback((data: SigningTypeSwitcherOption) => {
    if (data.id === AuthModalQuery.LOGIN) {
      replace({ search: createAuthQuery(AuthModalQuery.LOGIN) });
    }
    else {
      replace({ search: createAuthQuery(AuthModalQuery.SIGN) });
    }
  }, []);

  const getSelectedId = useCallback((): string => {
    if (search.startsWith(createAuthQuery(AuthModalQuery.LOGIN))) {
      return AuthModalQuery.LOGIN;
    }
    if (search.startsWith(createAuthQuery(AuthModalQuery.SIGN))) {
      return AuthModalQuery.SIGN;
    }
    return '';
  }, []);

  return (
    <SegmentedControl options={options}
                      onSelect={handleSelectOption}
                      className={styles.root}
                      selectedId={getSelectedId()} />
  );
};
